import { useMutation } from "@tanstack/react-query";
import { getHfrDetailsByHfrId, postCreateHealthFacility } from "apis";
import queryClient from "../../../instances/react-query-client";
import { getMyProfileQueryKeys } from "../get-my-profile";

const useGetHfrDetailsByHfrId = () => {
  return useMutation({
    mutationFn: getHfrDetailsByHfrId,
  });
};

export default useGetHfrDetailsByHfrId;
